import { isArray } from '@qcwp/utils'
import cnchar from 'cnchar'
import type { BrandResponse } from '~~/src/server/modules/car/types'
export interface BrandDict {
  brandId: string
  brandName: string
  brandNameInitial: string
  brandLogo: string
  brandFirstPinyin: string
  searchSetString: string
}
export function LogicSearchBrand() {
  const dictData = ref<BrandDict[]>([])
  function generateDict(data: BrandResponse): BrandDict {
    let brandFirstPinyin = cnchar.spell(data.brandName.trim(), 'first')
    if (isArray(brandFirstPinyin))
      brandFirstPinyin = brandFirstPinyin.join('_')
    brandFirstPinyin = brandFirstPinyin.toLocaleLowerCase()

    // console.log('brandPinyin', data.brandName, brandPinyin)
    return {
      brandId: data.id,
      brandName: data.brandName,
      brandNameInitial: data.brandNameInitial.toLocaleLowerCase(),
      brandLogo: data.coverImg,
      brandFirstPinyin,
      searchSetString: `${data.brandName} ${brandFirstPinyin}`,
    }
  }

  function initHandler(data: BrandResponse[]) {
    const dict = data.map(generateDict)
    dictData.value = dict
  }

  function search(keyword: string) {
    const result = dictData.value.filter(d => d.searchSetString.includes(keyword))
    return result
  }

  return {
    dictData,
    generateDict,
    initHandler,
    search,
  }
}
